import React from 'react';
interface MachineModel {
  name: string;
  subtitle: string;
  imageSrc: string;
  description: string;
  quoteUrl: string;
  infoUrl: string;
}
const machines: MachineModel[] = [{
  name: 'TTS - Duplex',
  subtitle: 'Multi-Tasking CNC Lathes with 2 independent turrets',
  imageSrc: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/SPINNER/SPINNER%20TTS65_Duplex_h365.png',
  description: 'TTS-Duplex is a high performance Turning Center for simultaneous machining with two turrets with main- and sub spindle, Y-axis, very dynamic axis, Spinner made high speed servo-turrets, anti-vibration special damping system for higher cutting volume, and 90 degrees slant bed design for best chip-removal. Usually used for medium and high volume turning of complex workpieces.',
  quoteUrl: 'https://www.peakedm.com/ContactPeakMachineSales.html?i515589:default[Product%20Title]=SPINNER%20TTS-Duplex',
  infoUrl: 'https://www.peakedm.com/m7/23570135--spinner-tts-duplex.html'
}, {
  name: 'TTS - Triplex',
  subtitle: 'Multi-Tasking CNC Lathes with 3 independent turrets',
  imageSrc: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/SPINNER/SPINNER%20TTS65_Triplex_h365.png',
  description: 'TTS-Triplex is a high performance Turning Center for simultaneous machining with three turrets with main- and sub spindle, two Y-axis, very dynamic axis, Spinner made high speed servo-turrets, anti-vibration special damping system for higher cutting volume, and 90 degrees slant bed design for best chip-removal. Usually used for medium and high volume turning of complex workpieces.',
  quoteUrl: 'https://www.peakedm.com/ContactPeakMachineSales.html?i515589:default[Product%20Title]=SPINNER%20TTS-Triplex',
  infoUrl: 'https://www.peakedm.com/m7/23570136--spinner-tts-triplex.html'
}];
export function MachineModelsSection() {
  return <div className="space-y-16" data-id="element-3865">
      {machines.map((machine, index) => <div key={index} className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-3866">
          <div className="bg-[#002d4d] text-white py-6 px-8" data-id="element-3867">
            <h3 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-3868">
              {machine.name}
            </h3>
            <p className="text-white/80 font-medium text-lg" data-id="element-3869">
              {machine.subtitle}
            </p>
          </div>

          <div className="p-8" data-id="element-3870">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-3871">
              <div className="flex justify-center" data-id="element-3872">
                <img src={machine.imageSrc} alt={machine.name} className="block max-h-[400px] w-auto object-contain rounded-lg" data-id="element-3873" />
              </div>
              <div data-id="element-3874">
                <p className="text-gray-700 text-lg leading-relaxed mb-6" data-id="element-3875">
                  {machine.description}
                </p>

                <div className="flex flex-col sm:flex-row gap-4" data-id="element-3876">
                  <a href={machine.quoteUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 bg-[#002d4d] text-white font-bold uppercase text-sm rounded-md hover:bg-orange transition-colors" data-id="element-3877">
                    <span className="mr-2" data-id="element-3878">+</span> REQUEST QUOTE
                  </a>
                  <a href={machine.infoUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#002d4d] text-[#002d4d] font-bold uppercase text-sm rounded-md hover:bg-[#002d4d] hover:text-white transition-colors" data-id="element-3879">
                    <span className="mr-2" data-id="element-3880">+</span> DISCOVER MORE
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>)}
    </div>;
}